import React from 'react';
import { inject, observer } from 'mobx-react';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';

@inject('page')
@observer
export default class SizeDetails extends React.Component {
  sizeOptions = [
    {
      value: 'small',
      label: 'Small',
      tip: 'Between 0 - 1kg',
      image: 'size-small.png',
    },
    {
      value: 'medium',
      label: 'Medium',
      tip: 'More than 1kg less than or equal to 2kg',
      image: 'size-medium.png',
    },
    {
      value: 'large',
      label: 'Large',
      tip: 'More than 2kg less than or equal to 3kg',
      image: 'size-large.png',
    },
    {
      value: 'extra-large',
      label: 'Extra Large',
      tip: 'Long and bulky items more than 3 kg',
      image: 'size-very-large.png',
    }
  ];

  render() {
    const page = this.props.page;

    return (
      <>
        <h6 className='tw-font-semibold'>Add item details</h6>
        <p className='tw-mb-4'>Select the size that best explain the item</p>

        {this.sizeOptions.map(option => (
          <label className='tw-flex tw-justify-center tw-p-2 hover:tw-bg-gray-100 hover:tw-border-primary tw-rounded-md mb-2' key={option.value}>
            <div className='tw-flex-1 tw-flex tw-gap-4 tw-items-center'>
              <img src={`/images/size/${option.image}`} width={70} height={70} />

              <div className='tw-flex-1' style={{height: 'fit-content'}}>
                <h4 className='tw-mb-0 tw-font-medium tw-text-lg'>{option.label}</h4>
                <p className='tw-mb-0 tw-font-normal'>{option.tip}</p>
              </div>
            </div>

            <input type='radio' name='size' value={option.value} onChange={page.setSize} className='tw-w-5' style={{height: 'fit-content'}}/>
          </label>
        ))}
        <ContinueButton disabled={!page.size}>Continue</ContinueButton>
      </>
    );
  }
}
